<template>
  <div id="app" class="theme-light">
    <Nav v-show="!generatorPage" :nav="nav" ref="mainNav"/>
    <Socials v-show="!generatorPage" />
    <div class="wrapper wrapper--light" :class="{'no-nav': generatorPage}">
      <router-view></router-view>
      <Footer v-show="!generatorPage" />
    </div>
  </div>
</template>

<script>
import Nav from "$components/Nav.vue";
import Footer from "$components/Footer.vue";
import Socials from "$components/Socials-tab.vue";
export default {
  name: "app",
  components: {
    Nav,
    Footer,
    Socials
  },
  data () {
    return {
      nav: [],
      generatorPage: false,
    }
  },
  watch:{
    $route (to, from){
      if (to.name.toLowerCase() === 'konfigurator' || to.name.toLowerCase() === 'konfigurator-zapisany') {
        this.generatorPage = true;
      } else {
        this.generatorPage = false;
      }
    }
  },
  mounted() {
    if (this.$route.name !== null && (this.$route.name.toLowerCase() === 'konfigurator' || this.$route.name.toLowerCase() === 'konfigurator-zapisany')) {
      this.generatorPage = true;
    } else {
      this.generatorPage = false;
    }
  }
};
</script>

<style lang="scss">
@import "~$scss/main";
</style>
